export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';



// WEBPACK FOOTER //
// ./src/loader/loaderActionTypes.js